import React from 'react';
import NavigateLink from '../../navigateLink/navigateLink';
import openModeEnum from '../../../../enums/openModeEnum';
import classes from '../ContentPromotionPopup.module.css';

const getButtonStyle = (button) => ({
    "--promotion-text-color": button.textColor,
    "--promotion-background-color": button.backgroundColor,
    "--promotion-border-color": button.borderColor,
});

const LinkButtonPromotion = ({ button, text, onClose }) => {
    const target = button.openMode === openModeEnum.SameWindow ? "_self" : "_blank";

    return (
        <span className={classes.ButtonLink}>
            <NavigateLink link={button.link} target={target}>
                <div className={classes.Button} style={getButtonStyle(button)} onClick={onClose}>
                    {text}
                </div>
            </NavigateLink>
        </span>
    );
};

export default LinkButtonPromotion;
